// Author thq
// Date 2020-12-09 16:11:10

class EmArchSupplier {
constructor({
        id = null,
        name = '',
        address = '',
        dutyParagraph = '',
        rating = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.address = address;
    this.dutyParagraph = dutyParagraph;
    this.rating = rating;
    this.remark = remark;
}
}

function newEntity() {
return new EmArchSupplier();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.em.archive.emArchSupplier.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'address',
        label: 'label.em.archive.emArchSupplier.grid.address',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'dutyParagraph',
        label: 'label.em.archive.emArchSupplier.grid.dutyParagraph',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'rating',
        label: 'label.em.archive.emArchSupplier.grid.rating',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchSupplier.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    nameFilter : "",
    addressFilter : "",
    dutyParagraphFilter : "",
    ratingFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.archive.emArchSupplier.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'addressFilter',
        label: 'label.em.archive.emArchSupplier.filter.address',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'dutyParagraphFilter',
        label: 'label.em.archive.emArchSupplier.filter.dutyParagraph',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'ratingFilter',
        label: 'label.em.archive.emArchSupplier.filter.rating',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.archive.emArchSupplier.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'address',
        label: 'label.em.archive.emArchSupplier.entity.address',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'dutyParagraph',
        label: 'label.em.archive.emArchSupplier.entity.dutyParagraph',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'rating',
        label: 'label.em.archive.emArchSupplier.entity.rating',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchSupplier.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmArchSupplier, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
